export enum ENoticeType {
  Offer = 'itemPropose',
  BalanceIn = 'balanceIncrease',
  BalanceOut = 'balanceCashOut',
  BalanceRequestOut = 'balanceRequestCashOut',
  Support = 'supportTicket',
  UserProductPurchased = 'itemRequestToSend',
  UserPurchase = 'itemBought',
}
